import React, {useEffect, useState} from 'react'
import {H3, H5} from '@components/UI/index.js'
import {FormStack, Select, Toggle} from '@components/UI/forms/index.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'
import {emit} from 'src/socketio/socketEmit.js'
import {ParcelCarrier} from '../../../../../server/functions/parcels/carrier.types.js'
import {Reseller} from '../../../../../server/functions/resellers/resellers.types.js'

type LyraProps = {
    customer: Customer
    onChange: (customer: Customer) => void
    reseller: Reseller
}

export default function LyraSettings({customer, onChange, reseller}: LyraProps) {
    const [loading, setLoading] = useState(false)
    const [availableShippingOptions, setAvailableShippingOptions] = useState([])

    useEffect(() => {
        if (!customer || !reseller?.settings?.parcels?.carriers) {
            return
        }

        const getCarriers = async () => {
            setLoading(true)

            try {
                const {data: carriers} = await emit<ParcelCarrier[]>('parcels.getCarriers')

                const enabledCarriers = carriers.filter((carrier) => {
                    return reseller.settings.parcels.carriers[carrier.name] && reseller.settings.parcels.carriers[carrier.name].enabled
                })

                const customerCarriers = enabledCarriers
                    .filter((carrier) => {
                        return (customer.settings.parcels.disabledCarriers || []).indexOf(carrier.name) === -1
                    })

                const products = Array.from(
                    new Set(customerCarriers.flatMap((carrier) => Object.keys(carrier.products)))
                )

                setAvailableShippingOptions(products)
            } finally {
                setLoading(false)
            }
        }

        getCarriers()
    }, [customer, reseller])

    function onChangeChecked(key: string, event) {
        customer.settings.webshops.lyra[key] = event.target.checked

        onChange(customer)
    }

    function onChangeValues(key: string, values) {
        customer.settings.webshops.lyra[key] = values

        onChange(customer)
    }

    return (
        <div>
            <H3 style={{marginBottom: 36}}>Lyra</H3>
            <H5 style={{marginBottom: 24}}>Instellingen</H5>

            <FormStack>
                <Toggle
                    label='Actief'
                    checked={customer.settings.webshops.lyra.active}
                    onChange={(event) => onChangeChecked('active', event)}
                />

                <Select
                    label='Verzendopties'
                    loading={loading}
                    options={availableShippingOptions.map((option) => ({value: option, title: option}))}
                    values={customer.settings.webshops.lyra.shippingOptions}
                    onChange={(event) => onChangeValues('shippingOptions', event.target.values)}
                />
            </FormStack>
        </div>
    )
}
